import { devListenPort as landingDevListenPort } from '../../app-landing-web/deployConfig.js';

const cfg =
  typeof window !== 'undefined' && window.__BLOG_CONFIG__
    ? window.__BLOG_CONFIG__
    : {
        signInUrl: '#',
        registerUrl: '#',
        stocksWebOrigin: '',
        marketingSiteUrl:
          typeof window !== 'undefined'
            ? `http://${window.location.hostname}:${landingDevListenPort}`
            : `http://localhost:${landingDevListenPort}`,
        blogCanonicalOrigin:
          typeof window !== 'undefined' ? window.location.origin : '',
      };

const articles = Array.isArray(window.__BLOG_ARTICLES__)
  ? window.__BLOG_ARTICLES__
  : [];

const currentPostSlug =
  window.location.pathname.match(/^\/blog\/([^/]+)$/)?.[1];
if (currentPostSlug) {
  const currentArticle = articles.find(
    (article) => article.slug === currentPostSlug,
  );
  const articleBody = document.querySelector('[data-blog-article-body]');
  if (currentArticle && articleBody?.innerHTML) {
    currentArticle.html = articleBody.innerHTML;
  }
}

function hydrateAfterFirstPaint() {
  void import('./hydrateBlogApp.jsx').then(({ hydrateBlogApp }) => {
    hydrateBlogApp(cfg, articles);
  });
}

if ('requestAnimationFrame' in window) {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(hydrateAfterFirstPaint);
  });
} else {
  window.setTimeout(hydrateAfterFirstPaint, 0);
}
